export const formatDPI = (value: string) => {
  return (
    value &&
    value
      .replace(/[^\d]/g, '')
      .replace(/(\d{4})(\d)/, '$1-$2')
      .replace(/(\d{5})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{5})\d+?$/, '$1')
      .slice(0, 15)
  )
}
